import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { QueryStaleTime } from "@/constants/query-stale-time";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { useMemo } from "react";

export const myFoodsQueryOptions = queryOptions({
  queryKey: [QueryKeys.MY_FOODS],
  staleTime: QueryStaleTime.LONG,
  queryFn: async () => {
    guardGetUserFromLocalStorage();
    const response = await MealsService.getMyFoodsApiV1MealsMyFoodsGet();
    return response.data.meals ?? [];
  },
});

export const useGetMyFoods = () => {
  const { data, isLoading, isError, error, refetch } = useQuery(myFoodsQueryOptions);

  const myFoodMealsSet = useMemo(() => {
    return new Set((data ?? []).map((meal) => meal.id).filter((id): id is string => Boolean(id)));
  }, [data]);

  return {
    myFoods: data ?? [],
    myFoodMealsSet,
    isLoading,
    isError,
    error,
    refetch,
  };
};
